/**
 * Partner-specific branding helpers for co-branded experiences that share a
 * whitelabel but need a different logo for a specific partner.
 */
import { PARTNER_ID_WTI_GLOBAL } from '@Shared/constants/partners';

export const WTI_SPREE_LOGO_PATH = 'img/logo/whitelabel/emburseSpend/WTI_Spree.svg';
export const WTI_SIGNUP_LOGO_HEIGHT = 64;
export const WTI_HEADER_LOGO_HEIGHT = 36;

type PartnerBrandingInput = {
  partnerId?: string;
  channel?: string;
  isWtiBranding?: boolean;
  defaultLogoPath?: string;
  defaultHeaderLogoPath?: string;
};

export function isWtiPartnerBranding({ partnerId, channel }: Pick<PartnerBrandingInput, 'partnerId' | 'channel'>) {
  return partnerId === PARTNER_ID_WTI_GLOBAL || channel === PARTNER_ID_WTI_GLOBAL;
}

function shouldUseWtiBranding({ partnerId, channel, isWtiBranding }: PartnerBrandingInput) {
  return isWtiBranding ?? isWtiPartnerBranding({ partnerId, channel });
}

export function getPartnerAppLogoPath({ partnerId, channel, isWtiBranding, defaultLogoPath }: PartnerBrandingInput) {
  return shouldUseWtiBranding({ partnerId, channel, isWtiBranding }) ? WTI_SPREE_LOGO_PATH : defaultLogoPath;
}

export function getPartnerSignupLogoStyle({ partnerId, channel, isWtiBranding }: PartnerBrandingInput) {
  return shouldUseWtiBranding({ partnerId, channel, isWtiBranding }) ? { height: WTI_SIGNUP_LOGO_HEIGHT } : undefined;
}

export function getPartnerHeaderLogoStyle({ partnerId, channel, isWtiBranding }: PartnerBrandingInput) {
  return shouldUseWtiBranding({ partnerId, channel, isWtiBranding })
    ? { display: 'block', height: WTI_HEADER_LOGO_HEIGHT, width: 'auto' }
    : undefined;
}

export function getPartnerHeaderLogoPath({ partnerId, channel, isWtiBranding, defaultHeaderLogoPath }: PartnerBrandingInput) {
  return shouldUseWtiBranding({ partnerId, channel, isWtiBranding }) ? WTI_SPREE_LOGO_PATH : defaultHeaderLogoPath;
}
